<template>
  <basic-container>
     <!-- 自定义搜索表单 -->
     <el-card class="search-card" shadow="never">
      <el-form :model="searchForm" :inline="true" size="small">
        <el-form-item label="MAC地址">
          <el-input 
            v-model="searchForm.mac" 
            placeholder="请输入MAC地址"
            clearable
            style="width: 200px;">
          </el-input>
        </el-form-item>
        
        <el-form-item label="HID">
          <el-input 
            v-model="searchForm.hid" 
            placeholder="请输入HID"
            clearable
            style="width: 200px;">
          </el-input>
        </el-form-item>
        
        <el-form-item label="AHID">
          <el-input 
            v-model="searchForm.ahid" 
            placeholder="请输入AHID"
            clearable
            style="width: 200px;">
          </el-input>
        </el-form-item>
        
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 350px;">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad">
      
      <template slot="menuLeft">
        <el-button 
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permissionList.delBtn"
          @click="handleDelete">
          批量删除
        </el-button>
      </template>
      
      <template slot="menu" slot-scope="scope">
        <el-button 
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permissionList.viewBtn"
          @click="handleView(scope.row)">
          查看
        </el-button>
        
        <el-button 
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permissionList.editBtn"
          @click="handleEdit(scope.row)">
          编辑
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { 
  getBlackList, 
  getBlackListDetail, 
  addBlackList, 
  updateBlackList, 
  deleteBlackList,
  batchDeleteBlackList 
} from "@/api/ad/blacklist";
import { mapGetters } from "vuex";

export default {
  name: 'AdBlackList',
  
  data() {
    return {
      form: {},
      searchForm: {
        mac: '',
        hid: '',
        ahid: '',
        timeRange: []
      },
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: false,
        searchMenuSpan: 24,
        border: true,
        index: false,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 8,
        column: [
          {
            label: "ID",
            prop: "id",
            span: 3,
            addDisplay: false,
            editDisplay: false,
            search: false,
          },
          {
            label: "MAC地址",
            prop: "mac",
            span: 5,
            search: true,
            searchLabelWidth: 120,
            rules: [{
              required: true,
              message: "请输入MAC地址",
              trigger: "blur"
            }, {
              pattern: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
              message: "请输入正确的MAC地址格式",
              trigger: "blur"
            }]
          },
          
          {
            label: "HID",
            prop: "hid",
            span: 8,
            minWidth: 200,
            addDisplay: false,
            editDisplay: false,
            search: true,
            searchLabelWidth: 120,
          },
          {
            label: "AHID",
            prop: "ahid",
            span: 8,
            minWidth: 200,
            search: true,
            searchLabelWidth: 120,
            rules: [{
              required: false,
              message: "请输入AHID",
              trigger: "blur"
            }]
          },
          {
            label: "操作人",
            prop: "tname",
            span: 3,
            addDisplay: false,
            editDisplay: false,
            search: false,
          },
          {
            label: "备注",
            prop: "comment",
            span: 12,
            minWidth: 120,
            type: "textarea",
            search: false,
            rules: [{
              required: false,
              message: "请输入备注",
              trigger: "blur"
            }, {
              max: 200,
              message: "备注不能超过200个字符",
              trigger: "blur"
            }],
            overHidden: true,
            tip: true,
            cellStyle: {
              'white-space': 'nowrap',
              'text-overflow': 'ellipsis',
              'overflow': 'hidden',
              'max-width': '200px'
            }
          },
          // 修复“更新时间区间”搜索不生效问题，需在搜索方法中处理updatetime为startTime和endTime
          {
            label: "更新时间",
            prop: "updatetime",
            span: 8,
            minWidth: 120,
            addDisplay: false,
            editDisplay: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      },
      data: []
    };
  },
  
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.adBlackList_add, false),
        viewBtn: this.vaildData(this.permission.adBlackList_view, false),
        delBtn: this.vaildData(this.permission.adBlackList_delete, false),
        editBtn: this.vaildData(this.permission.adBlackList_edit, false)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  
  mounted() {
    this.onLoad(this.page);
  },
  
  methods: {
    // 处理搜索
    handleSearch() {
      this.query = {};
      
      // 处理MAC地址
      if (this.searchForm.mac) {
        this.query.mac = this.searchForm.mac;
      }
      
      // 处理HID
      if (this.searchForm.hid) {
        this.query.hid = this.searchForm.hid;
      }
      
      // 处理AHID
      if (this.searchForm.ahid) {
        this.query.ahid = this.searchForm.ahid;
      }
      
      // 处理时间区间
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        this.query.startTime = this.searchForm.timeRange[0];
        this.query.endTime = this.searchForm.timeRange[1];
      }
      
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
    },
     
    // 处理重置
    handleReset() {
      this.searchForm = {
        mac: '',
        hid: '',
        ahid: '',
        timeRange: []
      };
      this.query = {};
      this.onLoad(this.page);
    },
    // 行保存（新增）
    rowSave(row, loading, done) {
      // 只提交允许编辑的字段
      const submitData = {
        mac: row.mac,
        ahid: row.ahid,
        comment: row.comment
      };
      
      addBlackList(submitData).then(res => {
        if (res.data.code === 200) {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "新增成功!"
          });
        } else {
          done();
          this.$message.error(res.data.msg || "新增失败");
        }
      }).catch(error => {
        done();
        console.log(error);
        this.$message.error("新增失败，请重试");
      });
    },
    
    // 行更新（编辑）
    rowUpdate(row, index, loading, done) {
      // 只提交允许编辑的字段
      const submitData = {
        id: row.id,
        mac: row.mac,
        ahid: row.ahid,
        comment: row.comment
      };
      
      updateBlackList(submitData).then(res => {
        if (res.data.code === 200) {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "更新成功!"
          });
        } else {
          done();
          this.$message.error(res.data.msg || "更新失败");
        }
      }).catch(error => {
        done();
        console.log(error);
        this.$message.error("更新失败，请重试");
      });
    },
    
    // 行删除
    rowDel(row) {
      this.$confirm("确定要删除这条记录吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return deleteBlackList(row.id);
      }).then(res => {
        if (res.data.code === 200) {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(error => {
        console.log(error);
        this.$message.error("删除失败，请重试");
      });
    },
    
    // 批量删除
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定要删除选中的数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return batchDeleteBlackList(this.ids);
      }).then(res => {
        if (res.data.code === 200) {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "批量删除成功!"
          });
          this.$refs.crud.toggleSelection();
        } else {
          this.$message.error(res.data.msg || "批量删除失败");
        }
      }).catch(error => {
        console.log(error);
        this.$message.error("批量删除失败，请重试");
      });
    },
    
    // 查看详情
    handleView(row) {
      this.form = { ...row };
      this.$refs.crud.rowView(row, row.$index);
    },
    
    // 编辑
    handleEdit(row) {
      this.form = { ...row };
      this.$refs.crud.rowEdit(row, row.$index);
    },
    
    // 打开前处理
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getBlackListDetail(this.form.id).then(res => {
          if (res.data.code === 200) {
            this.form = res.data.data;
          }
        });
      }
      done();
    },
    
    
    // 选择变化
    selectionChange(list) {
      this.selectionList = list;
    },
    
    // 选择清空
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    
    // 刷新
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    
    // 加载数据
    onLoad(page, params = {}) {
      this.loading = true;
      const requestData = {
        current: page.currentPage,
        size: page.pageSize,
        ...params
      };
      
      getBlackList(requestData).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取数据失败");
        }
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.$message.error("获取数据失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 设置操作栏宽度 */
.avue-crud__menu {
  min-width: 200px !important;
  width: 200px !important;
}

/* 确保操作按钮在一行显示 */
.avue-crud__menu .el-button {
  margin-right: 8px;
}

/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 300px;
  word-break: break-all;
  line-height: 1.5;
}

/* 自定义单元格样式 */
.truncate-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 备注字段样式 */
.comment-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 搜索表单样式 */
.avue-crud__search {
  .el-form-item {
    margin-bottom: 18px;
  }
}

/* 时间选择器样式 */
.el-date-editor--datetimerange {
  width: 100%;
}
</style>